import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CerrarturnoModalEdit } from "./modalcerrarturno";
import { ConsultaCorteModalList } from "./modales/modalconsultacorte";
import { GetFilasSaldoCajas } from "./modales/model";
import { FiltroTurnoComponent } from "./filtro";

type Entity = models.TurnoDto;
import { columnas } from "./columns";
import { fa } from "app/main/std";
const resource = resources.Turno;

const IniciarTurnoButton = kea.defaultProps(kea.Button, { children: "Iniciar turno", style: "info", iconClass: fa("clock-o") });

interface Props {
    permisos: models.Rol;
    filtro: models.FiltroTurno;
    onFiltroChange: (x: models.FiltroTurno) => void;
}

class TurnoListNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();
    onFinalizar = async (x: Entity) => {
        if (await kea.yesno("¿Finalizar este turno?", kea.formatDate(x.FechaEntrada) + " - " + x.NombreUsuario)) {
            await resource.FinalizarTurno(x.IdRegistro);
        }
    }

    onVerCorte = async (x: Entity) => {
        var saldosCajas = await resource.VerCorte(x.IdRegistro);
        var rows = GetFilasSaldoCajas(saldosCajas);
        const result = await this.modalManager.showModal(ConsultaCorteModalList, rows, x.IdRegistro);
    }

    onRegresar = () => history.go("../");
    onAgregar = () => history.go("./new");

    permisoIniciarTurno = (x: Props) => x.permisos.Turnos.VerIniciarTurno;

    private filtro = (props: Props) => props.filtro;

    private observable = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resource.Query, filtro);
        return obs;
    });

    render() {
        const cols = columnas(this, this.props.permisos);
        const puedeIniciar = this.permisoIniciarTurno(this.props);
        const observable = this.observable(this.props);
        const filtro = this.filtro(this.props);

        return (
            <div>
                <kea.Title titulo="Turnos" onRegresar={this.onRegresar}>
                    {
                        puedeIniciar &&
                        <IniciarTurnoButton onClick={this.onAgregar} />
                    }
                </kea.Title>
                <FiltroTurnoComponent value={filtro} onChange={this.props.onFiltroChange} />
                <kea.Grid2 columnas={cols} cookieKey={"TurnoListCookieKey"} items={observable} />
                {this.modalManager.component}
            </div>
        );
    }
}

const TurnoListRx = componentToRx(TurnoListNoRx);

export class TurnoList extends React.PureComponent<{}, { filtro: models.FiltroTurno }> {
    constructor(props) {
        super(props);
        this.state = { filtro: { Limite: 300 } };
    }

    onChange = (value: models.FiltroTurno) => new Promise<void>(resolve => this.setState({ filtro: value }, resolve));


    render() {
        return (
            <TurnoListRx
                permisos={resources.User.PermisoRx}
                filtro={this.state.filtro}
                onFiltroChange={this.onChange}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/list/list.tsx